"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationPanel_1 = require("./NotificationPanel");
exports.default = NotificationPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/NotificationPanel/index.js
// module id = 1397
// module chunks = 8